/*
Controller: InventoryIngestionSubmissions

Operations:
  bulkFamilyUpdate
  getInventoryIngestionSubmissions
  updateIngestionSubmission
  deleteSubmission
  unlinkSubmission
  mapFamilyWithExisting
  createNewFamily
  getIhRelatedFamilies
  splitFamily
*/
var Api = require('../config')
var BulkFamilyUpdateRequestDef = require('../definitions/BulkFamilyUpdateRequest')
var SubmissionDef = require('../definitions/Submission')
var MapFamilyRequestDef = require('../definitions/MapFamilyRequest')
var CreateNewFamilyRequestDef = require('../definitions/CreateNewFamilyRequest')
var SplitFamilyRequestDef = require('../definitions/SplitFamilyRequest')

var InventoryIngestionSubmissions = (function () {
  /*
  Operation: bulkFamilyUpdate
  Get inventory ingestion submissions
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion

  Responses:
    HTTP 200: Family bulk update response
    HTTP 400: Invalid request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Ingestion not found
  */
  function bulkFamilyUpdateInventoryIngestionSubmissions (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        BulkFamilyUpdateRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/bulk-update'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'patch',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getInventoryIngestionSubmissions
  Get inventory ingestion submission
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    submissionId: Id of the submission
  Responses:
    HTTP 200: Inventory ingestion submission Data
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Ingestion not found
  */
  function getInventoryIngestionSubmissionsInventoryIngestionSubmissions (inventoryIngestionId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateIngestionSubmission
  Update an existing Submission of any Inventory Ingestion
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
    submissionId: ID of the submission

  Responses:
    HTTP 200: Successful updated
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Submission or Ingestion not found
  */
  function updateIngestionSubmissionInventoryIngestionSubmissions (inventoryIngestionId, submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        SubmissionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteSubmission
  Delete inventory ingestion submission
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    submissionId: Id of the submission
  Responses:
    HTTP 200: Successful delete
    HTTP 400: Failed to delete submission
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function deleteSubmissionInventoryIngestionSubmissions (inventoryIngestionId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: unlinkSubmission
  Unlink submission from Ingestion
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    submissionId: Id of the submission
  Responses:
    HTTP 200: Successful unlinked
    HTTP 400: Failed to unlink
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: SubmissionId not found
  */
  function unlinkSubmissionInventoryIngestionSubmissions (inventoryIngestionId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}/unlink'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: mapFamilyWithExisting
  Map new family with existing live family
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
    bodyRequest: Mapping request data
  Responses:
    HTTP 200: Family mapping created successfully
    HTTP 400: Invalid request data
    HTTP 404: Submission or family not found
    HTTP 409: Mapping already exists
    HTTP 423: Family locked for edit
    HTTP 500: Internal server error
  */
  function mapFamilyWithExistingInventoryIngestionSubmissions (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        MapFamilyRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/map-family'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: createNewFamily
  Create new family from existing mapped submission
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
    submissionId: ID of the submission
    bodyRequest: Create new family request data
  Responses:
    HTTP 200: Family created successfully
    HTTP 400: Invalid request data
    HTTP 404: Submission or ingestion not found
    HTTP 409: Non Custom Ingestion
  */
  function createNewFamilyInventoryIngestionSubmissions (inventoryIngestionId, submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        CreateNewFamilyRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/create-new-family/{submissionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getIhRelatedFamilies
  Get related families for a given family in an ingestion
  Parameters:
    inventoryIngestionId: Unique identifier of the inventory ingestion.
    submissionId: Unique identifier of the submission.
    familyId: Unique identifier of the family.
  Responses:
    HTTP 200: Inventory ingestion submission Data
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Ingestion&#x2F;data not found
  */
  function getIhRelatedFamiliesInventoryIngestionSubmissions (inventoryIngestionId, submissionId, familyId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        if (!familyId) {
          throw new Error('familyId: Missing parameter')
        }
        if (familyId && !(typeof familyId === 'string')) {
          throw new Error('familyId: Wrong type: Got "' + (typeof familyId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/{submissionId}/relatedFamilies/{familyId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      path = path.replace('{' + 'familyId' + '}', familyId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: splitFamily
  Split family from existing mapped submission
  Parameters:
    inventoryIngestionId: ID of the inventory ingestion
    submissionId: ID of the submission
    bodyRequest: Split family request data
  Responses:
    HTTP 200: Family split successfully
    HTTP 400: Invalid request data
    HTTP 404: Submission or ingestion not found
    HTTP 409: Non Custom Ingestion
  */
  function splitFamilyInventoryIngestionSubmissions (inventoryIngestionId, submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        SplitFamilyRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/split-family/{submissionId}'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['bulkFamilyUpdate'] = bulkFamilyUpdateInventoryIngestionSubmissions
  ret['getInventoryIngestionSubmissions'] = getInventoryIngestionSubmissionsInventoryIngestionSubmissions
  ret['updateIngestionSubmission'] = updateIngestionSubmissionInventoryIngestionSubmissions
  ret['deleteSubmission'] = deleteSubmissionInventoryIngestionSubmissions
  ret['unlinkSubmission'] = unlinkSubmissionInventoryIngestionSubmissions
  ret['mapFamilyWithExisting'] = mapFamilyWithExistingInventoryIngestionSubmissions
  ret['createNewFamily'] = createNewFamilyInventoryIngestionSubmissions
  ret['getIhRelatedFamilies'] = getIhRelatedFamiliesInventoryIngestionSubmissions
  ret['splitFamily'] = splitFamilyInventoryIngestionSubmissions
  return ret
})()

module.exports = InventoryIngestionSubmissions
